export default "__VITE_ASSET__1af2a0be__"